export type PauseOverlayAction = 'resume' | 'toggle-sound' | 'menu';
export type ResultOverlayAction = 'restart' | 'menu';

type TouchRegion<TAction extends string> = {
  action: TAction;
  left: number;
  right: number;
  top: number;
  bottom: number;
};

const PAUSE_TOUCH_REGIONS: readonly TouchRegion<PauseOverlayAction>[] = [
  { action: 'resume', left: 66, right: 384, top: 479, bottom: 541 },
  { action: 'toggle-sound', left: 66, right: 384, top: 563, bottom: 617 },
  { action: 'menu', left: 66, right: 384, top: 628, bottom: 682 },
];

const RESULT_TOUCH_REGIONS: readonly TouchRegion<ResultOverlayAction>[] = [
  { action: 'restart', left: 80, right: 370, top: 464, bottom: 526 },
  { action: 'menu', left: 80, right: 370, top: 548, bottom: 602 },
];

function getActionAt<TAction extends string>(
  x: number,
  y: number,
  regions: readonly TouchRegion<TAction>[],
): TAction | null {
  return regions.find((region) => (
    x >= region.left
    && x <= region.right
    && y >= region.top
    && y <= region.bottom
  ))?.action ?? null;
}

export function getPauseOverlayActionAt(x: number, y: number): PauseOverlayAction | null {
  return getActionAt(x, y, PAUSE_TOUCH_REGIONS);
}

export function getResultOverlayActionAt(x: number, y: number): ResultOverlayAction | null {
  return getActionAt(x, y, RESULT_TOUCH_REGIONS);
}
